import { MAX_STROKE_WIDTH, MIN_STROKE_WIDTH } from "@/constants/dataset";

import SliderInput from "../SliderInput";

interface StrokeWidthSliderProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export default function StrokeWidthSlider({
  value,
  onChange,
  disabled
}: Readonly<StrokeWidthSliderProps>) {
  const handleChangeStrokeWidth = (value: number) => {
    let newValue = Number(value);

    // If the user typed a multi-digit number that exceeds max,
    // assume they intended to replace the value with the last digit.
    if (newValue > MAX_STROKE_WIDTH) {
      const strValue = String(value);
      if (strValue.length > 1) {
        const lastDigit = Number(strValue.slice(-1));
        newValue = Math.max(
          MIN_STROKE_WIDTH,
          Math.min(MAX_STROKE_WIDTH, lastDigit)
        );
      } else {
        newValue = MAX_STROKE_WIDTH;
      }
    }

    if (newValue < MIN_STROKE_WIDTH) newValue = MIN_STROKE_WIDTH;

    onChange(Math.round(newValue));
  };

  const handleChangeStrokeWidthSlider = (values: number[]) => {
    const newValue = Math.round(values[0]);
    if (newValue >= MIN_STROKE_WIDTH && newValue <= MAX_STROKE_WIDTH) {
      onChange(newValue);
    }
  };

  const strokeWidthValue = [
    Math.max(
      MIN_STROKE_WIDTH,
      Math.min(MAX_STROKE_WIDTH, value || MIN_STROKE_WIDTH)
    )
  ];
  const strokeWidthInputValue = Math.max(
    MIN_STROKE_WIDTH,
    Math.min(MAX_STROKE_WIDTH, Math.round(value || MIN_STROKE_WIDTH))
  );

  return (
    <div className="flex flex-col gap-2 w-full">
      <p className="text-xs text-txtPlaceholder">Stroke</p>
      <SliderInput
        valueSlider={strokeWidthValue}
        onChangeSlider={handleChangeStrokeWidthSlider}
        valueInput={strokeWidthInputValue}
        onChangeInput={handleChangeStrokeWidth}
        max={MAX_STROKE_WIDTH}
        disabled={disabled}
      />
    </div>
  );
}
